import React from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {Dialog, DialogContent} from "@mui/material";
import {FormattedMessage} from "react-intl";


import './UnAvailableContestsPopUp.style.scss';
const UnAvailableContestsPopUp = ({open, onClose, onOk}) => {
    return (
        <Dialog open={open} onClose={onClose} className="UnAvailableContestsPopUp">
            <DialogContent className="UnAvailableContestsContent">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Typography className="title">
                    <FormattedMessage id={'popUp.UnAvailableContests.title'}/>
                </Typography>
                <Typography className="subTitle">
                    <FormattedMessage id={'popUp.UnAvailableContests.subTitle'}/>
                </Typography>

                <div className={'actionButton'}>
                    <Button className="retry" onClick={onOk}>
                        <FormattedMessage id={'popUp.UnAvailableContests.backToLobby'}/>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default UnAvailableContestsPopUp;